<template>
  <div v-if="show">
    <div v-if="$page.props.flash.success">
      <v-alert
        type="success"
        closable
        :text="$page.props.flash.success"
        class="text-sm-subtitle-2"
      />
    </div>

    <div v-if="$page.props.flash.alert">
      <v-alert
          variant="flat"
          v-model="showDismissableAlert"
          type="warning" closable
          :text="$page.props.flash.alert"
          class="text-sm-subtitle-2"
          icon="fas fa-warning"
      />
    </div>

    <div v-if="Object.keys($page.props.errors).length > 0">
      <v-alert v-model="showDismissableAlert" type="error" closable
               :text="$page.props.flash.errors" class="text-sm-subtitle-2"

      />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        show: true,
        showDismissableAlert: true,
      }
    },
    watch: {
      '$page.props.flash': {
        handler() {
          this.show = true,
          this.showDismissableAlert = true
        },
        deep: true
      },
    },
    methods: {
      capitalize(word) {
        return word.charAt(0).toUpperCase() + word.slice(1)
      },
    }
  }
</script>
